import { Variant } from '../../common/components/atoms/Badge';

import { AutoDebitSettlementMethodStatus } from 'apollo/queries/autogenerate/schemas';

type Result = {
  title: string;
  variant: Variant | undefined;
};

export function getBadgeDetails(
  status?: AutoDebitSettlementMethodStatus
): Result {
  switch (status) {
    case AutoDebitSettlementMethodStatus.APPLIED:
      return { title: '申し込み中', variant: 'warning' };
    case AutoDebitSettlementMethodStatus.ACTIVE:
      return { title: 'ご利用中', variant: 'success' };
    case AutoDebitSettlementMethodStatus.PENDING:
      return { title: '来月より適用', variant: 'info' };
    default:
      return { title: '', variant: undefined };
  }
}
